export const DEFAULT_SELECT_OPTION = { value: '', label: '- Select -' };
